import { Stack } from '@astryxdesign/core/Stack'
import { Text } from '@astryxdesign/core/Text'
import HeroPage from '../components/HeroPage'
import StoreBadges from '../components/StoreBadges'

const APP_STORE_URL = "https://apps.apple.com/fr/app/padelr/id6657992480"

// Where /invitation/{code} lands when the app did not claim the link.
//
// This is the first screen a great many new players ever see - the community
// invitation emails link straight here - so it is the one view in this
// migration whose content was left strictly alone.
//
// Two things about it are odd, and both are deliberately preserved rather than
// quietly fixed:
//
//   - It offers only the App Store. The old file carried a goToPlayStore()
//     that nothing ever called, and the supporting line still says Google Play
//     is coming "bientôt" even though Main has linked the public Play listing
//     for some time. So the copy is stale and the Android half of this screen
//     is missing.
//   - The payload in the URL is never read. The screen says "install the app
//     first" and nothing more; it does not tell the reader which community
//     invited them, though the code to do it is one API call away.
//
// Both are content and product decisions rather than migration ones. Changing
// what this page says to a first-time visitor is not something to slip into a
// design-system change - see the comment on the plan.
export function InvitationView() {
    return (
        <HeroPage
            heading="Vous devez installer l'application avant de pouvoir utiliser l'invitation"
            supporting="Elle est disponible sur l'App store Apple et bientôt sur Google Play store"
        >
            <Stack gap={4} hAlign="center">
                <StoreBadges appStoreURL={APP_STORE_URL} />
                <Text as="p" type="supporting">Contact: contact at padelr dot app</Text>
            </Stack>
        </HeroPage>
    )
}

export default InvitationView
